module.exports = __webpack_public_path__ + "static/media/businessman-counting-money-japanese-yen-banknotes-while-making-agreement-min.3394c3a4.jpg";